import React, { useRef, useEffect } from 'react'
import './Mouse.css'

function App() {
  const circle1Ref = useRef(null)
  const circle2Ref = useRef(null)

  const mousemove = (event) => {
    let x = event.pageX;
    let y = event.pageY;
    circle1Ref.current.style.top = y + 'px';
    circle1Ref.current.style.left = x + 'px';
    circle2Ref.current.style.top = y + 'px';
    circle2Ref.current.style.left = x + 'px';
  }

  useEffect(() => {
    window.addEventListener('mousemove', mousemove)
    return () => {
      window.removeEventListener('mousemove', mousemove)
    }
  }, [])

  return (
    <div>
      <div ref={circle1Ref} className='circle1'></div>
      <div ref={circle2Ref} className='circle2'></div>
    </div>
  )
}

export default App